// OM Analyzer Event Names
export const OM_EVENTS = {
  ANALYSIS_STARTED: 'om_analysis_started',
  ANALYSIS_COMPLETED: 'om_analysis_completed',
  FIELD_CORRECTED: 'om_field_corrected',
  ANALYSIS_ERROR: 'om_analysis_error',
  OM_ADDED: 'om_added',
} as const;

// Event Properties Types
export interface OMAnalysisStartedProperties {
  user_id: string;
  property_id: string;
  property_name: string;
  file_size: number; // in bytes
  page_count: number;
}

export interface OMAnalysisCompletedProperties {
  user_id: string;
  property_id: string;
  duration: number; // how long the analysis took
  fields_extracted: number; // number of fields successfully extracted
}

export interface OMFieldCorrectedProperties {
  user_id: string;
  property_id: string;
  field_name: string; // which field was corrected
}

export interface OMAnalysisErrorProperties {
  user_id: string;
  property_id: string;
  error_type: 'file_processing' | 'extraction' | 'validation' | 'unknown';
  error_message: string;
}

export interface OMAddedProperties {
  user_id: string;
  property_id: string;
  property_name: string;
  file_size: number;
}
